/**
 * Created by jonas on 2022-01-11.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {NineToFive} from "../NineToFive";
import {NineToFiveSound} from "../sound/NineToFiveSound";
import {NineToFiveGameAssets} from "../NineToFiveGameAssets";
import {FreespinsOutroInformation} from "../components/FreespinsOutroInformation";

export class NineToFiveTransitionScreenView extends PIXI.Container implements StageLayer {
    protected button:ContinueButton;
    private clickCallback?:Function;
    private fsIntroBackground:PIXI.Sprite;
    private sfsIntroBackground:PIXI.Sprite;
    private maxWinBackground:PIXI.Sprite;
    private introSpine:PIXI.spine.Spine;
    private overtimeSpine:PIXI.spine.Spine;
    private noWinSpine:PIXI.spine.Spine;
    private maxWinSpine:PIXI.spine.Spine;
    private outroInformation:FreespinsOutroInformation;
    private gameIntro:PIXI.spine.Spine;
    private gameIntroTimeline:gsap.core.Timeline;

    constructor(name?:string) {
        super();
        this.name = name ? name : "NineToFiveTransitionScreenView";
        const coloredSquare = (color:string) => {
            const square = new PIXI.Sprite(PIXI.Texture.WHITE);
            square.tint = PIXI.utils.string2hex(color);
            square.position.set(360, 360);
            square.anchor.set(0.5, 0.5);
            square.alpha = 0.8;
            square.visible = false;
            return square;
        }
        this.fsIntroBackground = coloredSquare("#000099");
        this.sfsIntroBackground = coloredSquare("#cc0000");
        this.maxWinBackground = coloredSquare("#0000cc");
        this.maxWinBackground.alpha = 0.7

        //this.gameIntro = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.GAME_INTRO));
        //this.gameIntro.position.set(360,360);
        //this.gameIntro.visible = false;
        //this.gameIntro.name = "GameIntroLol";
        //this.gameIntroTimeline = gsap.timeline();

        this.introSpine = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.FS_INTRO));
        this.introSpine.position.set(360,300);

        this.overtimeSpine = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.FS_OVERTIME));
        this.overtimeSpine.position.set(360,300);
        this.overtimeSpine.visible = false;

        this.noWinSpine = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.NO_WIN_SPINE));
        this.noWinSpine.position.set(360,386);
        this.noWinSpine.visible = false;

        this.maxWinSpine = new PIXI.spine.Spine(NineToFive.assetLoader.getSpineAsset(NineToFiveGameAssets.MAX_WIN_SPINE));
        this.maxWinSpine.position.set(360,386);
        this.maxWinSpine.visible = false;

        this.outroInformation = new FreespinsOutroInformation();

        this.button = new ContinueButton();
        this.button.addClickCallback(() => this.onButtonClick());
        this.button.position.set(360, 610);
        this.button.pivot.set(this.button.width * 0.5, this.button.height * 0.5);
        this.button.enable(false);
        this.button.alpha = 0;

        this.addChild(this.fsIntroBackground);
        this.addChild(this.sfsIntroBackground);
        //this.addChild(this.gameIntro);
        this.addChild(this.maxWinBackground);
        this.addChild(this.introSpine);
        this.addChild(this.overtimeSpine);
        this.addChild(this.outroInformation);
        this.addChild(this.noWinSpine);
        this.addChild(this.maxWinSpine);
        this.addChild(this.button);
        this.alpha = 0;
        this.onResize();
    }

    onResize():void {
        if (NolimitApplication.isLandscape) {
            this.button.position.set(360, 610);
        } else {
            this.button.position.set(360, NolimitApplication.screenBounds.bottom - 250);
        }
        this.fsIntroBackground.width = NolimitApplication.screenBounds.width;
        this.fsIntroBackground.height = NolimitApplication.screenBounds.height;
        this.sfsIntroBackground.width = NolimitApplication.screenBounds.width;
        this.sfsIntroBackground.height = NolimitApplication.screenBounds.height;
        this.maxWinBackground.width = NolimitApplication.screenBounds.width;
        this.maxWinBackground.height = NolimitApplication.screenBounds.height;
    }

    private onButtonClick() {
        this.button.enable(false);
        if (this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        NineToFive.soundPlayer.playSound(NineToFiveSound.CONTINUE_BUTTON);
        gsap.to(this.button, {duration:0.2, alpha:0});
        delete this.clickCallback;
    }

    public noWin(version:string):gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.introSpine.visible = false;
                this.noWinSpine.visible = true;
                this.noWinSpine.state.setAnimation(0, `No_Win_${version}`, true);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.1}))
            .add(() => {}, '>1.5')
            .add(gsap.to(this, {alpha: 0, duration: 0.1}))
            .add(() =>  {
                this.noWinSpine.state.setEmptyAnimation(0, 0);
                this.noWinSpine.visible = false;
                this.introSpine.visible = true;
            });
    }

    public enableButton(cb:Function):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = cb;
            this.button.enable(true);
        });
        tl.add(gsap.to(this.button, {duration:0.2, alpha:1}));
        return tl;
    }

    private showIntroOutroThing(background:PIXI.Sprite, introSpineClip:string):gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                background.visible = true;
                this.introSpine.state.setAnimation(0, introSpineClip, true);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}));
    }

    private hideIntroOutroThing(background:PIXI.Sprite):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this, {alpha: 0, duration: 0.5}))
            .add(() =>  {
                background.visible = false;
                this.introSpine.state.setEmptyAnimation(0, 0);
            });
    }

    public showIntro():gsap.core.Timeline {
        return this.showIntroOutroThing(this.fsIntroBackground, "FS_Intro");
    }

    public hideIntro():gsap.core.Timeline {
        return this.hideIntroOutroThing(this.fsIntroBackground);
    }

    public showIntroSuper():gsap.core.Timeline {
        return this.showIntroOutroThing(this.sfsIntroBackground, "SFS_Intro");
    }

    public hideIntroSuper():gsap.core.Timeline {
        return this.hideIntroOutroThing(this.sfsIntroBackground);
    }

    public showUpgrade():gsap.core.Timeline {
        return this.showIntroOutroThing(this.sfsIntroBackground, "FS_Upgrade");
    }

    public hideUpgrade():gsap.core.Timeline {
        return this.hideIntroOutroThing(this.sfsIntroBackground);
    }

    public showMaxWin():gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.maxWinBackground.visible = true;
                this.introSpine.visible = false;
                this.maxWinSpine.visible = true;
                this.maxWinSpine.state.setAnimation(0, "Max_Win", true);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}));
    }

    public hideMaxWin():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this, {alpha: 0, duration: 0.5}))
            .add(() =>  {
                this.maxWinBackground.visible = false;
                this.introSpine.visible = true;
                this.maxWinSpine.visible = false;
                this.maxWinSpine.state.setEmptyAnimation(0, 0);
            });
    }

    public showOutro():gsap.core.Timeline {
        return gsap.timeline()
            .add(this.showIntroOutroThing(this.fsIntroBackground, "FS_Outro"))
            .add(this.outroInformation.showOutroInformation());
    }

    public hideOutro():gsap.core.Timeline {
        return gsap.timeline()
            .add(this.hideIntroOutroThing(this.fsIntroBackground))
            .add(this.outroInformation.hideOutroInformation());
    }

    public showOutroSuper():gsap.core.Timeline {
        return gsap.timeline()
            .add(this.showIntroOutroThing(this.sfsIntroBackground, "SFS_Outro"))
            .add(this.outroInformation.showOutroInformation());
    }

    public hideOutroSuper():gsap.core.Timeline {
        return gsap.timeline()
            .add(this.hideIntroOutroThing(this.sfsIntroBackground))
            .add(this.outroInformation.hideOutroInformation());
    }

    public showOvertime(amount:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(() =>  {
                this.introSpine.visible = false;
                this.overtimeSpine.visible = true;
                this.overtimeSpine.state.setAnimation(0, `FS_Overtime_${amount}`, true);
            })
            //.add(gsap.to(this, {alpha: 1, duration: 0.1}))
            .add(() => {
                this.alpha = 1;
            })
            .add(() => {}, '>1.2')
            .add(() => {
                this.alpha = 0;
            })
            //.add(gsap.to(this, {alpha: 0, duration: 0.1}))
            .add(() =>  {
                this.overtimeSpine.state.setEmptyAnimation(0, 0);
                this.introSpine.visible = true;
                this.overtimeSpine.visible = false;
            });
    }

    //public showGameIntro(): gsap.core.Timeline {
    //    this.gameIntroTimeline =  gsap.timeline()
    //        .add(() => {
    //            this.gameIntro.visible = true;
    //            this.gameIntro.state.setAnimation(0, `Intro_${Math.floor(Math.random() * 4) + 1}`, true)
    //        })
    //        .add(gsap.to(this, {alpha: 1, duration:0.1}), '<')
    //        .add(gsap.to(this, {alpha: 0, duration:0.1}), '>4.3')
    //        .add(() => {
    //            this.gameIntro.visible = false;
    //            this.gameIntro.state.setEmptyAnimation(0,0);
    //        })
    //        .addLabel("end");
    //    return this.gameIntroTimeline;
    //}

    //public killGameIntro(): gsap.core.Timeline {
    //    return this.gameIntroTimeline.seek("end", false);
    //}
}